<template>
  <div class="cmp-settings-user-details">
    <TextField2
      id="user_name"
      :placeholder="$t('username')"
      :label="$t('username')"
      :value="userDetails.usr.user_name"
      :disabled="false"
      @blur="e => onTextFieldValueChange(e)"
    />
    <TextField2
      id="password"
      :placeholder="$t('password')"
      :label="$t('password')"
      :value="userDetails.usr.password"
      :disabled="false"
      @blur="e => onTextFieldValueChange(e)"
      type="password"
    />
    <TextField2
      id="staff_email"
      :placeholder="$t('email_1')"
      :label="$t('email_1')"
      :value="userDetails.usr.staff_email"
      :disabled="false"
      @blur="e => onTextFieldValueChange(e)"
    />
    <TextField2
      id="job_title"
      :placeholder="$dft.capHead($t('jobtitle'))"
      :label="$dft.capHead($t('jobtitle'))"
      :value="userDetails.usr.job_title"
      :disabled="false"
      @blur="e => onTextFieldValueChange(e)"
    />
    <TextField2
      id="smtp_server"
      :placeholder="$t('smtp_server')"
      :label="$t('smtp_server')"
      :value="userDetails.usr.smtp_server"
      :disabled="false"
      @blur="e => onTextFieldValueChange(e)"
    />
    <TextField2
      id="smtp_username"
      :placeholder="$t('smtp_username')"
      :label="$t('smtp_username')"
      :value="userDetails.usr.smtp_username"
      :disabled="false"
      @blur="e => onTextFieldValueChange(e)"
    />
    <TextField2
      id="smtp_password"
      :placeholder="$t('smtp_password')"
      :label="$t('smtp_password')"
      :value="userDetails.usr.smtp_password"
      :disabled="false"
      @blur="e => onTextFieldValueChange(e)"
      type="password"
    />
    <Dropdown2
      :label="$t('language')"
      :placeholder="$t('language')"
      :i18nKey="true"
      :options="systemLanguagesTV"
      :selected="
        systemLanguagesTV.find(c => c.value == userDetails.usr.language)
      "
      v-on:selectedChange="e => onDropdownChange('language', e)"
    />
    <Checkbox2
      :id="'admin'"
      :label="'Admin'"
      :value="userDetailsAdmin"
      :placeholder="'Admin'"
      @input="onChecked"
    />
    <Checkbox2
      :id="'accounting_more_flag'"
      :label="'Accounting'"
      :value="userDetailsAccounting"
      :placeholder="'Accounting'"
      @input="onChecked"
      bb="0px"
    />
  </div>
</template>
<script>
import { defaultTextFieldConfig } from "../../../../plugins/text-field";
import { NotificationService } from "../../../../dt-plugins/notification/notification.service";
import { UserService } from "../../services/user.service";
import { mapGetters } from "vuex";
import * as ActionTypes from "../../store/types";
import { mapKeyToAction } from "../../../../store/global";
import { SettingsStoreNamespace as storeNS } from "../../store";

export default {
  data() {
    return {
      textFieldConfig: defaultTextFieldConfig(),
      passwd: "1234",
      //userDetailsAdmin:false,
      //userDetailsAccounting:false,
      rolesAllowed: []
    };
  },
  props: {
    userDetails: {
      required: true
    },
   
  },
  computed: {
    ...mapGetters(['systemLanguagesTV']
    ),
    roles: function() {
      return this.rolesAllowed || [];
    },
    userDetailsAdmin: function() {
      return this.roles.includes("admin");
    },
    userDetailsAccounting: function() {
      return this.roles.includes("accounting_more_flag");
    },
    permissions: function() {
        const permissionsStr = this.userDetails?.usr?.permissions;
        const permissions = permissionsStr ? JSON.parse(permissionsStr) : {};
        return permissions;
    }
  },
  watch: {
    userDetails: {
      immediate: true,
      handler: function(newVal, oldVal) {
        const permissionsStr = newVal?.usr?.permissions;
        const permissions = permissionsStr ? JSON.parse(permissionsStr) : {};
        this.rolesAllowed = permissions?.allowed?.roles || [];
      }
    }
  },
  methods: {
    ...mapKeyToAction(storeNS, [ActionTypes.UserDetails.UPDATE.MULTIPLE]),
    onTextFieldValueChange: function(event) {
      // console.log("PROPS",this.userDetails)
      // console.log(name, value);
      const { name, value } = event;
      this.$emit("changed", { name, value });
    },
    onDropdownChange: function(name, event) {
      this.$emit("changed", { name, value: event.value });
    },
    onChecked: function({ name, value }) {
      let roles = this.rolesAllowed;
      roles = roles.filter(r => r != name);
      if (value === true) {
        roles.push(name);
      }

      UserService.postHideModuleSection(
        JSON.stringify(roles),
        this.userDetails.uid
      );
      NotificationService.showNotification({
        text: "Saving Changes",
        timeout: 5000
      });

      this.rolesAllowed = roles;
      // this[ActionTypes.SelectedUser.SET.SINGLE]({flag: true, user: this.userDetails.usr});

      const permissions = JSON.stringify({...this.permissions, allowed: {roles}});
      this[ActionTypes.UserDetails.UPDATE.MULTIPLE]({usr: { ...this.userDetails.usr, permissions}});
    }
    //MARK: Methods
  }
};
</script>

<style lang="scss">
.cmp-settings-user-details {
  .forward-checkbox {
    display: flex;
    flex-direction: row;
    margin-left: 20px;
    .checkboxcontainer {
      max-width: 50px;
      margin-right: 10px;
    }
    .checkbox-label {
      margin-top: -3px;
    }
  }
}
</style>
